import { Component, Input, OnInit } from '@angular/core';
import { ImportService } from '../../../services/import.service';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-pro-import',
  templateUrl: './pro-import.component.html',
  styleUrls: ['./pro-import.component.scss']
})
export class ProImportComponent implements OnInit {

  @Input() showImportDetails = false;
  showReadyToMap = false;

  importType: string;
  importYear: number;
  importQuarter: string;

  importedDate: string;
  importerName: string;

  importExists: boolean = false;
  importTypeFound: boolean = false;
  // selectedProType;
  selectedDataSet;
  userDataSets;

  isFetchingDataSets = false;
  getDataSubscription;

  constructor(public importService: ImportService, private partnerService: PartnerService, private userService: UserService) {
    this.importService.showProImport$.subscribe((x) => {
      this.showImportDetails = x;
    })

    this.importService.importType$.subscribe((x) => {
      this.importType = x;
    });

    this.importService.importYear$.subscribe((x) => {
      this.importYear = x;
    });

    this.importService.importQuarter$.subscribe((x) => {
      this.importQuarter = x;
    });

    this.importService.showReadyToMap$.subscribe((x) => {
      this.showReadyToMap = x;
    });

    this.importService.importedDate$.subscribe((x) => {
      this.importedDate = x;
    });

    this.importService.importerName$.subscribe((x) => {
      this.importerName = x;
    })
   }

  ngOnInit() {

    //get data set for current user
    if (this.isFetchingDataSets == false) {
      this.isFetchingDataSets = true;
      this.getDataSubscription = this.partnerService.getUserDataSets(this.userService.currentUser.id).subscribe(resDataSets => {
        this.userDataSets = resDataSets;
        
        this.selectedDataSet = this.userDataSets.find(set => set.proType == this.importType);
        
        this.partnerService.setCurrentUserSelectedDataSet(this.selectedDataSet);
        // this.filterColumnsPerDataSet();
        this.importExists = true;
      });
      this.isFetchingDataSets = false;
    }
  }

  /**
   * Begins the pro import process
   */
  beginProImport(){
    //set active step to 1 (import)
    this.importService.setBreadCrumbActiveStep(1);
  }
  
  checkProType() {
    return this.userDataSets.some(item => item.proType === this.importType);
    // this.importTypeFound = this.userDataSets.some(item => item.proType === this.importType);
  }

  // checkImportExists() {
  //   return this.importService.importExists;
  // }

}
